const HEART_D = document.getElementById('hPath').getAttribute('d');
const SVG_VX=50,SVG_VY=50,SVG_VW=750,SVG_VH=750;
const SVG_PER_MM=SVG_VW/187;

const SIZE_STEPS=[];
for(let s=10;s<=300;s+=2)SIZE_STEPS.push(s);

let sizeIdx=SIZE_STEPS.indexOf(110);
let displayAngle=0;
const ANGLE_OFFSET=-54;
const actualAngle=()=>displayAngle+ANGLE_OFFSET;
let tx=535,ty=405,offsetMm=4;
let letterSpacing=0;  // em units passed to opentype
let activeFont='greatvibes',font=null,word='Mom';
const fontCache={};

const svgEl=document.getElementById('bSvg');
const tGrp=document.getElementById('tGrp');
const txPath=document.getElementById('txPath');
const brPath=document.getElementById('brPath');
const offPath=document.getElementById('offPath');
const ni=document.getElementById('ni');
const szL=document.getElementById('szL');
const agL=document.getElementById('agL');
const dlBtn=document.getElementById('dlBtn');

// WOFF files (not WOFF2 — opentype.js WOFF2/Brotli is unreliable)
// Multiple CDNs tried in order until one succeeds
const FONT_URLS={
  greatvibes:[
    'https://cdn.jsdelivr.net/npm/@fontsource/great-vibes/files/great-vibes-latin-400-normal.woff',
    'https://unpkg.com/@fontsource/great-vibes/files/great-vibes-latin-400-normal.woff',
    'https://cdn.jsdelivr.net/npm/@fontsource/great-vibes@5.0.8/files/great-vibes-latin-400-normal.woff',
  ],
  dancing:[
    'https://cdn.jsdelivr.net/npm/@fontsource/dancing-script/files/dancing-script-latin-700-normal.woff',
    'https://unpkg.com/@fontsource/dancing-script/files/dancing-script-latin-700-normal.woff',
    'https://cdn.jsdelivr.net/npm/@fontsource/dancing-script@5.0.8/files/dancing-script-latin-700-normal.woff',
  ],
  pinyon:[
    'https://cdn.jsdelivr.net/npm/@fontsource/pinyon-script/files/pinyon-script-latin-400-normal.woff',
    'https://unpkg.com/@fontsource/pinyon-script/files/pinyon-script-latin-400-normal.woff',
    'https://cdn.jsdelivr.net/npm/@fontsource/pinyon-script@5.0.3/files/pinyon-script-latin-400-normal.woff',
  ],
  pacifico:[
    'https://cdn.jsdelivr.net/npm/@fontsource/pacifico/files/pacifico-latin-400-normal.woff',
    'https://unpkg.com/@fontsource/pacifico/files/pacifico-latin-400-normal.woff',
    'https://cdn.jsdelivr.net/npm/@fontsource/pacifico@5.0.8/files/pacifico-latin-400-normal.woff',
  ],
};

let hoopOn=false;

function calcHoop(){
  if(!hoopOn) return null;
  const rOuter = 29;
  const rInner = 16;  // bigger inner hole
  const cy = HEART_TOP_Y - rOuter * 0.7 + 30;
  return {cx:HEART_CX, cy, rOuter, rInner};
}

async function loadActive(){
  dlBtn.disabled=true;
  if(fontCache[activeFont]){font=fontCache[activeFont];setReady();return;}

  for(const u of FONT_URLS[activeFont]){
    try{
      const r=await fetch(u);
      if(!r.ok) continue;
      fontCache[activeFont]=opentype.parse(await r.arrayBuffer());
      font=fontCache[activeFont];
      setReady(); return;
    }catch(e){ /* try next */ }
  }
  dlBtn.textContent='✗ Font failed';
}

// Same as loadActive but triggers auto-fit after the font loads (used on manual font switch)
async function loadActiveWithFit(){
  dlBtn.disabled=true;
  if(fontCache[activeFont]){font=fontCache[activeFont];setReadyWithFit();return;}

  for(const u of FONT_URLS[activeFont]){
    try{
      const r=await fetch(u);
      if(!r.ok) continue;
      fontCache[activeFont]=opentype.parse(await r.arrayBuffer());
      font=fontCache[activeFont];
      setReadyWithFit(); return;
    }catch(e){ /* try next */ }
  }
  dlBtn.textContent='✗ Font failed';
}
function setReadyWithFit(){dlBtn.disabled=false;measureHeartSpan();schedRender(true);}
function setReady(){
  dlBtn.disabled=false;
  // Measure the heart anchor point so left-edge positioning works,
  // but don't change the size (preserve the 110% default)
  measureHeartSpan();
  schedRender(false);
}

function getSize(){return 160*(SIZE_STEPS[sizeIdx]/100);}
function getStrokeW(){
  if(activeFont==='greatvibes') return getSize()*0.0275;
  if(activeFont==='pinyon')     return getSize()*0.018;
  return 0;
}

// ── Hoop geometry ────────────────────────────────────────────
// Mirrors the reference plaque generator: 70% of ring sticks out above the
// heart, 30% overlaps inside so the offset layer connects them seamlessly.
const HEART_TOP_Y = 83;    // topmost SVG y of the heart outline
const HEART_CX    = 400;   // horizontal centre

function getViewBoxExtent(){
  const h=calcHoop();
  // Heart actual bounds in SVG space (measured from path)
  let minX=96,minY=83,maxX=698,maxY=688;
  // Expand for text position
  if(font){
    const lt=buildLocalTextNoCache();
    if(lt){
      const rad=actualAngle()*Math.PI/180;
      const cos=Math.cos(rad),sin=Math.sin(rad);
      // Approximate rotated text bbox corners
      const bb=lt.bb;
      const corners=[[bb.x1,bb.y1],[bb.x2,bb.y1],[bb.x2,bb.y2],[bb.x1,bb.y2]];
      for(const[cx,cy]of corners){
        const rx=cx*cos-cy*sin+tx, ry=cx*sin+cy*cos+ty;
        minX=Math.min(minX,rx); maxX=Math.max(maxX,rx);
        minY=Math.min(minY,ry); maxY=Math.max(maxY,ry);
      }
    }
  }
  const PAD=offsetMm*SVG_PER_MM+30;
  if(h){
    minY=Math.min(minY, h.cy-h.rOuter-PAD);
    minX=Math.min(minX, h.cx-h.rOuter-PAD);
    maxX=Math.max(maxX, h.cx+h.rOuter+PAD);
  }
  return {
    minX: minX-PAD, minY: minY-PAD,
    maxX: maxX+PAD, maxY: maxY+PAD
  };
}
// Cache-free version for bounds calc (doesn't need full path)
function buildLocalTextNoCache(){
  if(!font||!word.trim()) return null;
  const sz=getSize();
  const opts={kerning:true, letterSpacing};
  const pb=font.getPath(word,0,0,sz,opts).getBoundingBox();
  if(isNaN(pb.x1)) return null;
  const ox=-pb.x1-heartSpanL, oy=-(pb.y1+(pb.y2-pb.y1)/2);
  const p=font.getPath(word,ox,oy,sz,opts);
  return {d:p.toPathData(2), bb:p.getBoundingBox(), sz};
}

function getViewBox(){
  const e=getViewBoxExtent();
  return `${Math.floor(e.minX)} ${Math.floor(e.minY)} ${Math.ceil(e.maxX-e.minX)} ${Math.ceil(e.maxY-e.minY)}`;
}

function updateHoopSVG(){
  const h=calcHoop();
  svgEl.setAttribute('viewBox', getViewBox());  // always update viewBox
  const grp=document.getElementById('hoopGroup');
  if(!h){ grp.setAttribute('display','none'); return; }
  grp.setAttribute('display','');
  const ic=document.getElementById('hoopInner');
  ic.setAttribute('cx',h.cx); ic.setAttribute('cy',h.cy); ic.setAttribute('r',h.rInner);
}

function buildLocalText(){
  if(!font||!word.trim())return null;
  const sz=getSize();
  const opts={kerning:true, letterSpacing};
  const pb=font.getPath(word,0,0,sz,opts).getBoundingBox();
  if(isNaN(pb.x1))return null;
  // Anchor left edge of text to the left heart boundary (-heartSpanL)
  // so the text always starts at the heart's left side
  const ox = -pb.x1 - heartSpanL;
  const oy = -(pb.y1+(pb.y2-pb.y1)/2);
  const p=font.getPath(word,ox,oy,sz,opts);
  return{d:p.toPathData(2),bb:p.getBoundingBox(),sz};
}

function buildBridge(lt){
  return null;
}

// ── Heart mask for span measurement ─────────────────────────
let heartCanvas=null, heartData=null;
function ensureHeartMask(){
  if(heartCanvas) return;
  heartCanvas=document.createElement('canvas');
  heartCanvas.width=800; heartCanvas.height=800;
  const ctx=heartCanvas.getContext('2d');
  ctx.fillStyle='#000';
  ctx.fill(new Path2D(HEART_D));
  heartData=ctx.getImageData(0,0,800,800).data;
}
function heartAt(x,y){
  const xi=Math.round(x),yi=Math.round(y);
  if(xi<0||xi>=800||yi<0||yi>=800) return false;
  return heartData[(yi*800+xi)*4+3]>127;
}

// Measure the span of the heart along the text direction through (tx,ty)
// Returns left extent L and right extent R separately
let heartSpanL=0; // stored so buildLocalText can anchor the left edge

function measureHeartSpan(){
  ensureHeartMask();
  const rad=actualAngle()*Math.PI/180;
  const cos=Math.cos(rad),sin=Math.sin(rad);
  let L=0,R=0;
  for(let d=0;d<=700;d++){
    if(heartAt(tx+d*cos, ty+d*sin)) R=d;
    if(heartAt(tx-d*cos, ty-d*sin)) L=d;
  }
  heartSpanL=L;
  // Target width: full left extent + 85% of right extent
  // Left edge will be anchored at -L so it always touches the heart left side
  return L + R * 0.85;
}

// Binary-search for the font size whose text width equals the heart span
function autoFitSize(){
  if(!font||!word.trim()) return;
  const span=measureHeartSpan();
  if(span<30) return; // not on heart
  const opts={kerning:true,letterSpacing};
  let lo=8,hi=600;
  for(let i=0;i<40;i++){
    const mid=(lo+hi)/2;
    const bb=font.getPath(word,0,0,mid,opts).getBoundingBox();
    if((bb.x2-bb.x1)<span) lo=mid; else hi=mid;
  }
  const pct=Math.round((lo+hi)/2/160*100);
  sizeIdx=SIZE_STEPS.reduce((best,s,i)=>
    Math.abs(s-pct)<Math.abs(SIZE_STEPS[best]-pct)?i:best,0);
  szL.textContent=SIZE_STEPS[sizeIdx]+'%';
}

async function computeOffset(lt,brD){
  // Use the actual viewBox extent (expands when hoop is active)
  const vb=getViewBoxExtent();
  const vW=vb.maxX-vb.minX, vH=vb.maxY-vb.minY;

  const SC=2, offSVG=offsetMm*SVG_PER_MM, LW=offSVG*2;
  const PAD=Math.ceil(LW*SC)+24;
  const cW=Math.ceil(vW*SC)+PAD*2, cH=Math.ceil(vH*SC)+PAD*2;
  const cv=document.createElement('canvas'); cv.width=cW; cv.height=cH;
  const ctx=cv.getContext('2d');
  ctx.fillStyle=ctx.strokeStyle='#000'; ctx.lineJoin='round'; ctx.lineCap='round';

  const ox=-vb.minX*SC+PAD, oy=-vb.minY*SC+PAD;

  ctx.save(); ctx.setTransform(SC,0,0,SC,ox,oy);
  ctx.lineWidth=LW; ctx.fill(new Path2D(HEART_D)); ctx.stroke(new Path2D(HEART_D)); ctx.restore();

  const hoop=calcHoop();
  if(hoop){
    ctx.save(); ctx.setTransform(SC,0,0,SC,ox,oy);
    ctx.lineWidth=LW;
    ctx.beginPath(); ctx.arc(hoop.cx,hoop.cy,hoop.rOuter,0,Math.PI*2);
    ctx.fill(); ctx.stroke(); ctx.restore();
  }

  if(lt){
    const rad=actualAngle()*Math.PI/180;
    ctx.save(); ctx.setTransform(SC,0,0,SC,ox,oy);
    ctx.translate(tx,ty); ctx.rotate(rad); ctx.lineWidth=LW;
    ctx.fill(new Path2D(lt.d)); ctx.stroke(new Path2D(lt.d));
    if(brD){ ctx.fill(new Path2D(brD)); ctx.stroke(new Path2D(brD)); }
    ctx.restore();
  }

  const px=ctx.getImageData(0,0,cW,cH).data;
  const mask=new Uint8Array(cW*cH);
  for(let i=0;i<cW*cH;i++) mask[i]=px[i*4+3]>15?1:0;

  const DX=[1,0,-1,0], DY=[0,1,0,-1];

  const ext=new Uint8Array(cW*cH); const q=[];
  for(let x=0;x<cW;x++){
    if(!mask[x]&&!ext[x]){ext[x]=1;q.push(x);}
    const b=(cH-1)*cW+x; if(!mask[b]&&!ext[b]){ext[b]=1;q.push(b);}
  }
  for(let y=1;y<cH-1;y++){
    if(!mask[y*cW]&&!ext[y*cW]){ext[y*cW]=1;q.push(y*cW);}
    const r=y*cW+cW-1; if(!mask[r]&&!ext[r]){ext[r]=1;q.push(r);}
  }
  for(let h=0;h<q.length;h++){
    const idx=q[h],x=idx%cW,y=Math.floor(idx/cW);
    for(let d=0;d<4;d++){
      const nx=x+DX[d],ny=y+DY[d];
      if(nx<0||nx>=cW||ny<0||ny>=cH)continue;
      const ni=ny*cW+nx;
      if(!mask[ni]&&!ext[ni]){ext[ni]=1;q.push(ni);}
    }
  }

  const hVis=new Uint8Array(cW*cH); const holeStarts=[];
  for(let y=0;y<cH;y++) for(let x=0;x<cW;x++){
    const i=y*cW+x;
    if(!mask[i]&&!ext[i]&&!hVis[i]){
      const hq=[i]; hVis[i]=1; let hh=0;
      while(hh<hq.length){
        const hi=hq[hh++],hx=hi%cW,hy=Math.floor(hi/cW);
        for(let d=0;d<4;d++){
          const nx=hx+DX[d],ny=hy+DY[d];
          if(nx<0||nx>=cW||ny<0||ny>=cH)continue;
          const ni=ny*cW+nx;
          if(!mask[ni]&&!ext[ni]&&!hVis[ni]){hVis[ni]=1;hq.push(ni);}
        }
      }
      // Threshold: heart interior = hundreds of thousands of canvas px.
      // Letter counters (G loop, M curl) = a few thousand px max.
      // 30000 px at SC=2 skips all letter holes, keeps only the heart cavity.
      if(hq.length>30000) holeStarts.push([x,y]);
    }
  }

  function traceContour(startX,startY,hitFn){
    const raw=[]; let bx=startX,by=startY,bd=0;
    for(let step=0;step<(cW+cH)*8;step++){
      raw.push([bx,by]); let ok=false;
      for(let t=0;t<4;t++){
        const nd=(bd-1+4+t)&3,nx=bx+DX[nd],ny=by+DY[nd];
        if(hitFn(nx,ny)){bd=nd;bx=nx;by=ny;ok=true;break;}
      }
      if(!ok)break; if(step>4&&bx===startX&&by===startY)break;
    }
    return raw;
  }

  // ── Convert raw pixel trace → smooth SVG sub-path ───────────
  // 300 source points, light 3-pt average, 2 Chaikin passes → tight but smooth
  function rawToSub(raw){
    if(raw.length<6)return '';
    const skip=Math.max(1,Math.floor(raw.length/300));
    let pts=[];
    for(let i=0;i<raw.length;i+=skip)
      pts.push([(raw[i][0]-PAD)/SC+vb.minX,(raw[i][1]-PAD)/SC+vb.minY]);

    // Single light average pass — just enough to remove pixel-grid noise
    const n0=pts.length, sm=[];
    for(let i=0;i<n0;i++){
      const a=pts[(i-1+n0)%n0],b=pts[i],c=pts[(i+1)%n0];
      sm.push([(a[0]*0.25+b[0]*0.5+c[0]*0.25),(a[1]*0.25+b[1]*0.5+c[1]*0.25)]);
    }
    pts=sm;

    // 2 Chaikin passes
    for(let p=0;p<2;p++){
      const n=pts.length,nxt=[];
      for(let i=0;i<n;i++){
        const a=pts[i],b=pts[(i+1)%n];
        nxt.push([a[0]*.75+b[0]*.25,a[1]*.75+b[1]*.25]);
        nxt.push([a[0]*.25+b[0]*.75,a[1]*.25+b[1]*.75]);
      }
      pts=nxt;
    }
    const f=v=>v.toFixed(2);
    let d=`M${f(pts[0][0])},${f(pts[0][1])}`;
    for(let i=0;i<pts.length;i++){
      const p1=pts[i],p2=pts[(i+1)%pts.length];
      d+=` Q${f(p1[0])},${f(p1[1])} ${f((p1[0]+p2[0])/2)},${f((p1[1]+p2[1])/2)}`;
    }
    return d+'Z';
  }

  let sx=-1,sy=-1;
  outer:for(let y=0;y<cH;y++) for(let x=0;x<cW;x++) if(mask[y*cW+x]){sx=x;sy=y;break outer;}
  if(sx<0)return '';
  const hitFilled=(x,y)=>x>=0&&x<cW&&y>=0&&y<cH&&!!mask[y*cW+x];
  let fullPath=rawToSub(traceContour(sx,sy,hitFilled));

  const hitHole=(x,y)=>x>=0&&x<cW&&y>=0&&y<cH&&!mask[y*cW+x]&&!ext[y*cW+x];
  for(const[hx,hy]of holeStarts){
    const sub=rawToSub(traceContour(hx,hy,hitHole));
    if(sub) fullPath+=' '+sub;
  }

  return fullPath;
}

let renderTm=null;
let shouldAutoFit=true; // auto-fit on word/font/angle/position changes

function schedRender(autoFit=true){
  shouldAutoFit=autoFit;
  clearTimeout(renderTm);
  renderTm=setTimeout(doRender,100);
}

async function doRender(){
  if(shouldAutoFit) autoFitSize();
  const lt=buildLocalText(),br=buildBridge(lt),sw=getStrokeW();
  if(lt){
    txPath.setAttribute('d',lt.d);
    txPath.setAttribute('stroke-width',sw>0?sw:0);
    txPath.setAttribute('stroke',sw>0?'#111111':'none');
    brPath.setAttribute('d',br||'');
  }else{txPath.setAttribute('d','');brPath.setAttribute('d','');}
  tGrp.setAttribute('transform',`translate(${tx},${ty}) rotate(${actualAngle()})`);
  updateHoopSVG();
  const offD=await computeOffset(lt,br);
  offPath.setAttribute('d',offD);
}

// ── Boolean union of all black elements for export ──────────────────────────
// Rasterises heart + stroke-expanded text, traces outer + hole contours,
// returns a single compound path string (fill-rule evenodd handles holes).
async function computeBlackUnion(lt){
  const SC=2, PAD=24;
  const vb=getViewBoxExtent();
  const vW=vb.maxX-vb.minX, vH=vb.maxY-vb.minY;
  const cW=Math.ceil(vW*SC)+PAD*2, cH=Math.ceil(vH*SC)+PAD*2;

  const cv=document.createElement('canvas'); cv.width=cW; cv.height=cH;
  const ctx=cv.getContext('2d');
  ctx.fillStyle=ctx.strokeStyle='#000';
  ctx.lineJoin='round'; ctx.lineCap='round';
  const ox=-vb.minX*SC+PAD, oy=-vb.minY*SC+PAD;

  // Heart (filled, no stroke needed)
  ctx.save(); ctx.setTransform(SC,0,0,SC,ox,oy);
  ctx.fill(new Path2D(HEART_D)); ctx.restore();

  // Text + stroke expansion (makes Great Vibes bold path)
  if(lt){
    const sw=getStrokeW();
    const rad=actualAngle()*Math.PI/180;
    ctx.save(); ctx.setTransform(SC,0,0,SC,ox,oy);
    ctx.translate(tx,ty); ctx.rotate(rad);
    ctx.fill(new Path2D(lt.d));
    if(sw>0){
      ctx.lineWidth=sw;  // in SVG user-space; canvas scales via transform
      ctx.stroke(new Path2D(lt.d));
    }
    ctx.restore();
  }

  const px=ctx.getImageData(0,0,cW,cH).data;
  const mask=new Uint8Array(cW*cH);
  for(let i=0;i<cW*cH;i++) mask[i]=px[i*4+3]>127?1:0;

  const DX=[1,0,-1,0], DY=[0,1,0,-1];

  // Flood-fill exterior
  const ext=new Uint8Array(cW*cH); const q=[];
  for(let x=0;x<cW;x++){
    if(!mask[x]&&!ext[x]){ext[x]=1;q.push(x);}
    const b=(cH-1)*cW+x; if(!mask[b]&&!ext[b]){ext[b]=1;q.push(b);}
  }
  for(let y=1;y<cH-1;y++){
    if(!mask[y*cW]&&!ext[y*cW]){ext[y*cW]=1;q.push(y*cW);}
    const r=y*cW+cW-1; if(!mask[r]&&!ext[r]){ext[r]=1;q.push(r);}
  }
  for(let h=0;h<q.length;h++){
    const idx=q[h],x=idx%cW,y=Math.floor(idx/cW);
    for(let d=0;d<4;d++){
      const nx=x+DX[d],ny=y+DY[d];
      if(nx<0||nx>=cW||ny<0||ny>=cH)continue;
      const ni=ny*cW+nx;
      if(!mask[ni]&&!ext[ni]){ext[ni]=1;q.push(ni);}
    }
  }

  // Find holes
  const hVis=new Uint8Array(cW*cH); const holeStarts=[];
  for(let y=0;y<cH;y++) for(let x=0;x<cW;x++){
    const i=y*cW+x;
    if(!mask[i]&&!ext[i]&&!hVis[i]){
      const hq=[i]; hVis[i]=1; let hh=0;
      while(hh<hq.length){
        const hi=hq[hh++],hx=hi%cW,hy=Math.floor(hi/cW);
        for(let d=0;d<4;d++){
          const nx=hx+DX[d],ny=hy+DY[d];
          if(nx<0||nx>=cW||ny<0||ny>=cH)continue;
          const ni=ny*cW+nx;
          if(!mask[ni]&&!ext[ni]&&!hVis[ni]){hVis[ni]=1;hq.push(ni);}
        }
      }
      if(hq.length>400) holeStarts.push([x,y]);
    }
  }

  function traceContour(startX,startY,hitFn){
    const raw=[]; let bx=startX,by=startY,bd=0;
    for(let step=0;step<(cW+cH)*8;step++){
      raw.push([bx,by]); let ok=false;
      for(let t=0;t<4;t++){
        const nd=(bd-1+4+t)&3,nx=bx+DX[nd],ny=by+DY[nd];
        if(hitFn(nx,ny)){bd=nd;bx=nx;by=ny;ok=true;break;}
      }
      if(!ok)break; if(step>4&&bx===startX&&by===startY)break;
    }
    return raw;
  }

  function rawToSub(raw){
    if(raw.length<6)return '';
    const skip=Math.max(1,Math.floor(raw.length/320));
    let pts=[];
    for(let i=0;i<raw.length;i+=skip)
      pts.push([(raw[i][0]-PAD)/SC+vb.minX,(raw[i][1]-PAD)/SC+vb.minY]);
    for(let p=0;p<4;p++){
      const n=pts.length,nxt=[];
      for(let i=0;i<n;i++){
        const a=pts[i],b=pts[(i+1)%n];
        nxt.push([a[0]*.75+b[0]*.25,a[1]*.75+b[1]*.25]);
        nxt.push([a[0]*.25+b[0]*.75,a[1]*.25+b[1]*.75]);
      }
      pts=nxt;
    }
    const f=v=>v.toFixed(2);
    let d=`M${f(pts[0][0])},${f(pts[0][1])}`;
    for(let i=0;i<pts.length;i++){
      const p1=pts[i],p2=pts[(i+1)%pts.length];
      d+=` Q${f(p1[0])},${f(p1[1])} ${f((p1[0]+p2[0])/2)},${f((p1[1]+p2[1])/2)}`;
    }
    return d+'Z';
  }

  let sx=-1,sy=-1;
  outer:for(let y=0;y<cH;y++) for(let x=0;x<cW;x++) if(mask[y*cW+x]){sx=x;sy=y;break outer;}
  if(sx<0)return '';

  const hitFilled=(x,y)=>x>=0&&x<cW&&y>=0&&y<cH&&!!mask[y*cW+x];
  let fullPath=rawToSub(traceContour(sx,sy,hitFilled));

  const hitHole=(x,y)=>x>=0&&x<cW&&y>=0&&y<cH&&!mask[y*cW+x]&&!ext[y*cW+x];
  for(const[hx,hy]of holeStarts){
    const sub=rawToSub(traceContour(hx,hy,hitHole));
    if(sub) fullPath+=' '+sub;
  }
  return fullPath;
}

let drag=false,dStart=null,dTX=0,dTY=0;
function svgPt(e){const pt=svgEl.createSVGPoint(),s=e.touches?e.touches[0]:e;pt.x=s.clientX;pt.y=s.clientY;return pt.matrixTransform(svgEl.getScreenCTM().inverse());}
tGrp.addEventListener('mousedown',e=>{e.preventDefault();drag=true;dStart=svgPt(e);dTX=tx;dTY=ty;tGrp.style.cursor='grabbing';});
tGrp.addEventListener('touchstart',e=>{e.preventDefault();drag=true;dStart=svgPt(e);dTX=tx;dTY=ty;},{passive:false});
window.addEventListener('mousemove',e=>{if(!drag)return;const c=svgPt(e);tx=dTX+(c.x-dStart.x);ty=dTY+(c.y-dStart.y);tGrp.setAttribute('transform',`translate(${tx},${ty}) rotate(${actualAngle()})`)});
window.addEventListener('touchmove',e=>{if(!drag)return;e.preventDefault();const c=svgPt(e);tx=dTX+(c.x-dStart.x);ty=dTY+(c.y-dStart.y);tGrp.setAttribute('transform',`translate(${tx},${ty}) rotate(${actualAngle()})`);},{passive:false});
window.addEventListener('mouseup',()=>{if(drag){drag=false;tGrp.style.cursor='grab';schedRender(false);}});
window.addEventListener('touchend',()=>{if(drag){drag=false;schedRender(false);}});

ni.addEventListener('input',e=>{word=e.target.value;schedRender(true);});
document.getElementById('szU').addEventListener('click',()=>{if(sizeIdx<SIZE_STEPS.length-1)sizeIdx++;szL.textContent=SIZE_STEPS[sizeIdx]+'%';schedRender(false);});
document.getElementById('szD').addEventListener('click',()=>{if(sizeIdx>0)sizeIdx--;szL.textContent=SIZE_STEPS[sizeIdx]+'%';schedRender(false);});
document.getElementById('agU').addEventListener('click',()=>{displayAngle=Math.min(114,displayAngle+3);agL.textContent=(displayAngle>0?'+':'')+displayAngle+'°';schedRender(false);});
document.getElementById('agD').addEventListener('click',()=>{displayAngle=Math.max(-36,displayAngle-3);agL.textContent=(displayAngle>0?'+':'')+displayAngle+'°';schedRender(false);});

document.getElementById('lsU').addEventListener('click',()=>{
  letterSpacing=Math.round((letterSpacing+0.02)*100)/100;
  document.getElementById('lsL').textContent=(letterSpacing>0?'+':'')+letterSpacing.toFixed(2);
  schedRender(true);
});
document.getElementById('lsD').addEventListener('click',()=>{
  letterSpacing=Math.round((letterSpacing-0.02)*100)/100;
  document.getElementById('lsL').textContent=(letterSpacing>0?'+':'')+letterSpacing.toFixed(2);
  schedRender(true);
});
document.getElementById('offSeg').addEventListener('click',e=>{
  const b=e.target.closest('.sb');if(!b)return;
  document.querySelectorAll('#offSeg .sb').forEach(x=>x.classList.remove('on'));
  b.classList.add('on');offsetMm=parseInt(b.dataset.off);schedRender();
});
document.getElementById('fontSeg').addEventListener('click',e=>{
  const b=e.target.closest('.sb');if(!b)return;
  document.querySelectorAll('#fontSeg .sb').forEach(x=>x.classList.remove('on'));
  b.classList.add('on');activeFont=b.dataset.font;
  ni.className = activeFont==='pacifico'?'fp':activeFont==='dancing'?'fds':activeFont==='pinyon'?'fps':'';
  loadActiveWithFit();
});

document.getElementById('hoopToggle').addEventListener('click',()=>{
  hoopOn=!hoopOn;
  const btn=document.getElementById('hoopToggle');
  if(hoopOn){ btn.classList.add('on'); btn.textContent='✓ Hanging Circle On'; }
  else       { btn.classList.remove('on'); btn.textContent='Add Hanging Circle'; }
  schedRender(false);
});

dlBtn.addEventListener('click',()=>{
  if(!font||!word.trim())return;
  dlBtn.disabled=true;dlBtn.textContent='⟳ Exporting…';
  setTimeout(async()=>{
    const lt=buildLocalText(),br=buildBridge(lt);
    const [offD, blackD] = await Promise.all([
      computeOffset(lt,br),
      computeBlackUnion(lt),
    ]);
    const vbE=getViewBoxExtent();
    const dW=vbE.maxX-vbE.minX;  // design width
    const dH=vbE.maxY-vbE.minY;  // design height
    const GAP=20;                  // gap between designs in SVG units
    const boardW=dW*2+GAP;
    const boardH=dH;
    const mmW=((boardW)/SVG_PER_MM).toFixed(1);
    const mmH=((boardH)/SVG_PER_MM).toFixed(1);

    // Translate paths from vbE space → 0-based space
    const dx=-vbE.minX, dy=-vbE.minY;

    // Hoop circle
    const h=calcHoop();
    const hoopBase=h?`<circle cx="${h.cx.toFixed(1)}" cy="${h.cy.toFixed(1)}" r="${h.rInner}" fill="none" stroke="#FF0000" stroke-width="1"/>`:'';
    const hoopRight=h?`<circle cx="${h.cx.toFixed(1)}" cy="${h.cy.toFixed(1)}" r="${h.rInner}" fill="none" stroke="#000000" stroke-width="1"/>`:'';

    const xml=`<?xml version="1.0" encoding="UTF-8"?>
<!-- Heart Laser Cut | ${word} | Left=Base(red) Right=Top(black) | Both: 1px outline -->
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${boardW.toFixed(1)} ${boardH.toFixed(1)}" width="${mmW}mm" height="${mmH}mm">

  <!-- LEFT: Base / red cut layer -->
  <g id="BASE_LAYER" transform="translate(${dx},${dy})">
    <path d="${offD}" fill="none" stroke="#FF0000" stroke-width="1"/>
    ${hoopBase}
  </g>

  <!-- RIGHT: Top / black engrave layer -->
  <g id="TOP_LAYER" transform="translate(${(dx+dW+GAP).toFixed(1)},${dy})">
    <path d="${blackD}" fill="none" stroke="#000000" stroke-width="1" fill-rule="evenodd"/>
    ${hoopRight}
  </g>

</svg>`;
    const blob=new Blob([xml],{type:'image/svg+xml;charset=utf-8'});
    const url=URL.createObjectURL(blob);
    const a=Object.assign(document.createElement('a'),{href:url,download:`heart-${word.toLowerCase().replace(/[^a-z0-9]/g,'-')}.svg`});
    document.body.appendChild(a);a.click();document.body.removeChild(a);URL.revokeObjectURL(url);
    dlBtn.disabled=false;dlBtn.textContent='✓ Downloaded!';
    setTimeout(()=>dlBtn.textContent='↓ Download SVG',2500);
  },30);
});

loadActive();